 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1YOUNGMASTERLU from '@/components/0_chapter1youngmasterlu'
 import A_CHAPTER2BACKMOUNTAINBAMBOOFOREST from '@/components/1_chapter2backmountainbambooforest'
 import A_CHAPTER3MUTUALDEPENDENCE from '@/components/2_chapter3mutualdependence'
 import A_CHAPTER4BODYTRAININGTECHNIQUE from '@/components/3_chapter4bodytrainingtechnique'
 import A_CHAPTER5RUTHLESSNESS from '@/components/4_chapter5ruthlessness'
 import A_CHAPTER6BONEREFININGPILL from '@/components/5_chapter6bonerefiningpill'
 import A_CHAPTER7YINDIFFERENCEANDYANGERROR from '@/components/6_chapter7yindifferenceandyangerror'
 import A_CHAPTER8NINECOLDPALMS from '@/components/7_chapter8ninecoldpalms'
 import A_CHAPTER9ANGERCOMBINED from '@/components/8_chapter9angercombined'
 import A_CHAPTER10WISEFIGHTING from '@/components/9_chapter10wisefighting'
 import A0_CHAPTER11ITISDIFFICULTTOESCAPEDEATH from '@/components/10_chapter11itisdifficulttoescapedeath'
 import A1_CHAPTER12FLIGHTWITHSEVEREINJURY from '@/components/11_chapter12flightwithsevereinjury'
 import A2_CHAPTER13POVERTYSTRICKENWATER from '@/components/12_chapter13povertystrickenwater'
 import A3_CHAPTER14RIVERBANK from '@/components/13_chapter14riverbank'
 import A4_CHAPTER15PATHOFTHEVOID from '@/components/14_chapter15pathofthevoid'
 import A5_CHAPTER16TRAVELOVERNIGHT from '@/components/15_chapter16travelovernight'
 import A6_CHAPTER17ZHENQICONDENSATION from '@/components/16_chapter17zhenqicondensation'
 import A7_CHAPTER18YINDIFFERENCEANDYANGERROR from '@/components/17_chapter18yindifferenceandyangerror'
 import A8_CHAPTER19WITTYFLIGHT from '@/components/18_chapter19wittyflight'
 import A9_CHAPTER20LUJIALINGYUAN from '@/components/19_chapter20lujialingyuan'
 import A0_CHAPTER21TWOPIECESOFJADEWALL from '@/components/20_chapter21twopiecesofjadewall'
 import A1_CHAPTER22JIANGHULANGZHONG from '@/components/21_chapter22jianghulangzhong'
 import A2_CHAPTER23MOUNTAINEERINGHERB from '@/components/22_chapter23mountaineeringherb'
 import A3_CHAPTER24XUANLEVELEXPERT from '@/components/23_chapter24xuanlevelexpert'
 import A4_CHAPTER25THREEYEARSLATER from '@/components/24_chapter25threeyearslater'
 import A5_CHAPTER26WEAKCROWNYEAR from '@/components/25_chapter26weakcrownyear'
 import A6_CHAPTER27LEAVINGTOWN from '@/components/26_chapter27leavingtown'
 import A7_CHAPTER28INEFFABLEIRONSWORD from '@/components/27_chapter28ineffableironsword'
 import A8_CHAPTER29BLOODDRINKINGBERSERKKNIFE from '@/components/28_chapter29blooddrinkingberserkknife'
 import A9_CHAPTER30WHITEROBEDMAIDEN from '@/components/29_chapter30whiterobedmaiden'
 import A0_CHAPTER31AERIALART from '@/components/30_chapter31aerialart'
 import A1_CHAPTER32THOUSANDGOLDBODY from '@/components/31_chapter32thousandgoldbody'
 import A2_CHAPTER33BLOODPUPILGHOSTWOLF from '@/components/32_chapter33bloodpupilghostwolf'
 import A3_CHAPTER34LIFEANDDEATHWITH from '@/components/33_chapter34lifeanddeathwith'
 import A4_CHAPTER35JUSTANIDIOT from '@/components/34_chapter35justanidiot'
 import A5_CHAPTER36WILDKNIFEDRINKINGBLOOD from '@/components/35_chapter36wildknifedrinkingblood'
 import A6_CHAPTER37WHITEBONE from '@/components/36_chapter37whitebone'
 import A7_CHAPTER38BLACKIRONSWORD from '@/components/37_chapter38blackironsword'
 import A8_CHAPTER39HALFWAYTHROUGHENCOUNTER from '@/components/38_chapter39halfwaythroughencounter'
 import A9_CHAPTER40WHITECLOTHEDYOUTH from '@/components/39_chapter40whiteclothedyouth'
 import A0_CHAPTER41THEYARESIMPLYCOURTINGDEATH from '@/components/40_chapter41theyaresimplycourtingdeath'
 import A1_CHAPTER42UNBELIEVABLE from '@/components/41_chapter42unbelievable'
 import A2_CHAPTER43FOLKLIFECOLLEGE from '@/components/42_chapter43folklifecollege'
 import A3_CHAPTER44CULTIVATIONASSESSMENT from '@/components/43_chapter44cultivationassessment'
 import A4_CHAPTER45PHASEOUT from '@/components/44_chapter45phaseout'
 import A5_CHAPTER46VERYSTRANGE from '@/components/45_chapter46verystrange'
 import A6_CHAPTER47DARKSIDE from '@/components/46_chapter47darkside'
 import A7_CHAPTER48THETOPEXPERT from '@/components/47_chapter48thetopexpert'
 import A8_CHAPTER49CUTTINGDOWNTREES from '@/components/48_chapter49cuttingdowntrees'
 import A9_CHAPTER50FEARLESS from '@/components/49_chapter50fearless'
 import A0_CHAPTER51BASICCOMMONSENSE from '@/components/50_chapter51basiccommonsense'
 import A1_CHAPTER52SURPRISEDDISCOVERY from '@/components/51_chapter52surpriseddiscovery'
 import A2_CHAPTER53HUNDREDSOFKILOGRAMSOFIRONCOAT from '@/components/52_chapter53hundredsofkilogramsofironcoat'
 import A3_CHAPTER54HEAVYCOST from '@/components/53_chapter54heavycost'
 import A4_CHAPTER55MASSTARGETED from '@/components/54_chapter55masstargeted'
 import A5_CHAPTER56SELFABUSING from '@/components/55_chapter56selfabusing'
 import A6_CHAPTER57MONSTER from '@/components/56_chapter57monster'
 import A7_CHAPTER58ETHICS from '@/components/57_chapter58ethics'
 import A8_CHAPTER59DELIBERATEDIFFICULTIES from '@/components/58_chapter59deliberatedifficulties'
 import A9_CHAPTER60BULLSHIT from '@/components/59_chapter60bullshit'
 import A0_CHAPTER61VOMITINGOVERANDOVER from '@/components/60_chapter61vomitingoverandover'
 import A1_CHAPTER62SAD from '@/components/61_chapter62sad'
 import A2_CHAPTER63BEAUTYATTACK from '@/components/62_chapter63beautyattack'
 import A3_CHAPTER64MYWOMAN from '@/components/63_chapter64mywoman'
 import A4_CHAPTER65ECCENTRICSPIRIT from '@/components/64_chapter65eccentricspirit'
 import A5_CHAPTER66MANOEUVRE from '@/components/65_chapter66manoeuvre'
 import A6_CHAPTER67BEAUTIFULFACE from '@/components/66_chapter67beautifulface'
 import A7_CHAPTER68SHOWOFFWEALTHANDWEALTH from '@/components/67_chapter68showoffwealthandwealth'
 import A8_CHAPTER69PRICELESSCITY from '@/components/68_chapter69pricelesscity'
 import A9_CHAPTER70ALLACTING from '@/components/69_chapter70allacting'
 import A0_CHAPTER71REPENTANCE from '@/components/70_chapter71repentance'
 import A1_CHAPTER72NINEMYSTICALJADEWALL from '@/components/71_chapter72ninemysticaljadewall'
 import A2_CHAPTER73WHATDIDYOUSAY from '@/components/72_chapter73whatdidyousay'
 import A3_CHAPTER74STRUGGLINGTOTHEBITTEREND from '@/components/73_chapter74strugglingtothebitterend'
 import A4_CHAPTER75ENEMYMEETING from '@/components/74_chapter75enemymeeting'
 import A5_CHAPTER76HYPEROPHTHALMIA from '@/components/75_chapter76hyperophthalmia'
 import A6_CHAPTER77TWOWOMEN from '@/components/76_chapter77twowomen'
 import A7_CHAPTER78LATENIGHTTALK from '@/components/77_chapter78latenighttalk'
 import A8_CHAPTER79TWOGREATMARTIALTECHNIQUES from '@/components/78_chapter79twogreatmartialtechniques'
 import A9_CHAPTER80NOBIGDEAL from '@/components/79_chapter80nobigdeal'
 import A0_CHAPTER81EASILYBEAT from '@/components/80_chapter81easilybeat'
 import A1_CHAPTER82BLACKMOSQUITO from '@/components/81_chapter82blackmosquito'
 import A2_CHAPTER83BUMPYROAD from '@/components/82_chapter83bumpyroad'
 import A3_CHAPTER84NOEYES from '@/components/83_chapter84noeyes'
 import A4_CHAPTER85SUSPICION from '@/components/84_chapter85suspicion'
 import A5_CHAPTER86CHRONICPOISON from '@/components/85_chapter86chronicpoison'
 import A6_CHAPTER87LONGEVITYCITY from '@/components/86_chapter87longevitycity'
 import A7_CHAPTER88SPEECHTEASING from '@/components/87_chapter88speechteasing'
 import A8_CHAPTER89HUNDREDPOISONPILL from '@/components/88_chapter89hundredpoisonpill'
 import A9_CHAPTER90ONACCOUNT from '@/components/89_chapter90onaccount'
 import A0_CHAPTER91DRAWRESULTS from '@/components/90_chapter91drawresults'
 import A1_CHAPTER92RAGEONTHESPOT from '@/components/91_chapter92rageonthespot'
 import A2_CHAPTER93THISISIMPOSSIBLE from '@/components/92_chapter93thisisimpossible'
 import A3_CHAPTER94MIDNIGHTVISITOR from '@/components/93_chapter94midnightvisitor'
 import A4_CHAPTER95CELESTIALCHARM from '@/components/94_chapter95celestialcharm'
 import A5_CHAPTER96ACUTENESS from '@/components/95_chapter96acuteness'
 import A6_CHAPTER97TOTALDESPAIR from '@/components/96_chapter97totaldespair'
 import A7_CHAPTER98AMANWHOUNDERSTANDSTHESWORD from '@/components/97_chapter98amanwhounderstandsthesword'
 import A8_CHAPTER99STRUGGLEFORMEN from '@/components/98_chapter99struggleformen'
 import A9_CHAPTER100ZODIACFOETUS from '@/components/99_chapter100zodiacfoetus'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1youngmasterlu",
 			"name" : "0_chapter1youngmasterlu",
 			"component" : A_CHAPTER1YOUNGMASTERLU
 		},
 		{
 			"path" : "/1_chapter2backmountainbambooforest",
 			"name" : "1_chapter2backmountainbambooforest",
 			"component" : A_CHAPTER2BACKMOUNTAINBAMBOOFOREST
 		},
 		{
 			"path" : "/2_chapter3mutualdependence",
 			"name" : "2_chapter3mutualdependence",
 			"component" : A_CHAPTER3MUTUALDEPENDENCE
 		},
 		{
 			"path" : "/3_chapter4bodytrainingtechnique",
 			"name" : "3_chapter4bodytrainingtechnique",
 			"component" : A_CHAPTER4BODYTRAININGTECHNIQUE
 		},
 		{
 			"path" : "/4_chapter5ruthlessness",
 			"name" : "4_chapter5ruthlessness",
 			"component" : A_CHAPTER5RUTHLESSNESS
 		},
 		{
 			"path" : "/5_chapter6bonerefiningpill",
 			"name" : "5_chapter6bonerefiningpill",
 			"component" : A_CHAPTER6BONEREFININGPILL
 		},
 		{
 			"path" : "/6_chapter7yindifferenceandyangerror",
 			"name" : "6_chapter7yindifferenceandyangerror",
 			"component" : A_CHAPTER7YINDIFFERENCEANDYANGERROR
 		},
 		{
 			"path" : "/7_chapter8ninecoldpalms",
 			"name" : "7_chapter8ninecoldpalms",
 			"component" : A_CHAPTER8NINECOLDPALMS
 		},
 		{
 			"path" : "/8_chapter9angercombined",
 			"name" : "8_chapter9angercombined",
 			"component" : A_CHAPTER9ANGERCOMBINED
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js